// extracted by mini-css-extract-plugin
export default {"ctn":"zoom_ctn__6QX7h","imgBox1":"zoom_imgBox1__pIQh5","textBox":"zoom_textBox__1VKlQ","imgBox2":"zoom_imgBox2__Vkygf","backgroundBox":"zoom_backgroundBox__1r1TG"};